// extracted by mini-css-extract-plugin
export var section = "styles-module--section--1FiZo";
export var box = "styles-module--box--1hjmW";
export var title = "styles-module--title--3Xt-b";
export var button = "styles-module--button--3TXbx";
export var content = "styles-module--content--fNn__";